import Vue from "vue";
import { GridPlugin, Page, Filter, Sort, Toolbar, Search, Edit, CommandColumn, ForeignKey, DetailRow } from "@syncfusion/ej2-vue-grids";
import TitleMixin from "@/mixins/title";
import SpinnerMixin from "@/mixins/spinner";
import GridMixin from "@/mixins/syncfusion/grid";
import { CustomUrlAdaptor } from "@/syncfusion/CustomUrlAdaptor";
import { DataManager } from "@syncfusion/ej2-data";
import { mapGetters } from "vuex";
Vue.use(GridPlugin);
export default Vue.extend({
    mixins: [TitleMixin, SpinnerMixin, GridMixin],
    data() {
        return {
            title: this.$t("dailyWorkAvailability.title"),
            employee: {},
            offices: [],
            data: new DataManager({
                url: process.env.VUE_APP_API_BASE_URL + `employees/${this.$route.params.employeeId != undefined ? this.$route.params.employeeId : this.$store.getters["account/getEmployeeId"]}/daily-work-availabilities/grid-data`,
                removeUrl: process.env.VUE_APP_API_BASE_URL + `employees/${this.$route.params.employeeId != undefined ? this.$route.params.employeeId : this.$store.getters["account/getEmployeeId"]}/daily-work-availabilities/grid-delete`,
                adaptor: new CustomUrlAdaptor()
            }),
            filterOptions: { type: "Menu" },
            sortOptions: {
                columns: [
                    { field: "OfficeId", direction: "Ascending" },
                    { field: "ValidFrom", direction: "Descending" }
                ]
            },
            pageSettings: { pageSize: 10 },
            toolbarOptions: [
                {
                    text: this.$t("shared.add"),
                    tooltipText: this.$t("shared.add"),
                    prefixIcon: "e-add",
                    id: "Custom_Add"
                }
            ],
            editSettings: {
                allowEditing: false,
                allowAdding: false,
                allowDeleting: true,
                showDeleteConfirmDialog: true,
                mode: "Dialog"
            },
            commands: [
                {
                    type: "Custom_Edit",
                    buttonOption: { cssClass: "e-flat", iconCss: "e-edit e-icons" }
                },
                {
                    type: "Delete",
                    buttonOption: { cssClass: "e-flat", iconCss: "e-delete e-icons" }
                }
            ]
        };
    },
    provide: {
        grid: [CommandColumn, ForeignKey, Page, Filter, Sort, Toolbar, Search, Edit, DetailRow]
    },
    computed: {
        ...mapGetters({
            hasMultipleOffices: "account/hasMultipleOffices",
            getEmployeeId: "account/getEmployeeId"
        }),
        employeeId() {
            if (this.$route.params.employeeId != undefined)
                return this.$route.params.employeeId;
            return this.getEmployeeId;
        }
    },
    methods: {
        toolbarClick(args) {
            if (args.item.id == "Custom_Add") {
                if (this.$route.params.employeeId != undefined)
                    return this.$router.push(`/employees/${this.employeeId}/daily-work-availabilities/create`);
                return this.$router.push(`/daily-work-availabilities/create`);
            }
        },
        commandClick(args) {
            if (args.commandColumn && args.commandColumn.type === "Custom_Edit") {
                if (this.$route.params.employeeId != undefined)
                    return this.$router.push(`/employees/${this.employeeId}/daily-work-availabilities/edit/${args.rowData.Id}`);
                return this.$router.push(`/daily-work-availabilities/edit/${args.rowData.Id}`);
            }
        }
    },
    async mounted() {
        this.showSpinner();
        try {
            this.employee = await this.$store.dispatch("employee/get", {
                id: this.employeeId
            });
            this.setTitle(`${this.title} - ${this.employee.name} ${this.employee.surname}`);
            this.hideSpinner();
        }
        catch (errors) {
            this.hideSpinner();
            this.$toast.showDangerToast(this.$t("shared.toastFailureTitle"), this.$t("shared.toastFailureContent", {
                error: errors[0].message
            }));
            await this.$router.push("/employees");
        }
    }
});
